export default __webpack_public_path__ + "static/media/NandanLogo.f6f7197c.png";